import { useSearchParams } from 'react-router-dom'

/** Raw `from` query value (e.g. `HOME`); empty string when absent. */
export function useElitePlansFromParam() {
  const [searchParams] = useSearchParams()
  return searchParams.get('from') ?? ''
}
